<template>
  <report-mobile-shift-rows
    :loading="Boolean(busy)"
    :rows="cards"
    :stats="kpis"
    :search="searchText"
    empty-icon="mdi-bowl-mix-outline"
  ></report-mobile-shift-rows>
</template>

<script>
import CompanyDesktopMultiMeals from "@/components/company-report/desktop/screens/multi/CompanyDesktopMultiMeals.vue";
import ReportMobileShiftRows from "@/components/report/mobile/ReportMobileShiftRows.vue";
import hasMultiMobile from "../../hasMultiMobile";

/**
 * Mobilni "Obroci" firme "više restorana": obrok sa ukupnim brojem i brojem po smeni ("5 + 2R" = 5 kupaca i 2
 * restoranu), od najvećeg ka manjem. Restorani, smene i period su u zaglavlju, pretraga u lupi. Računa kao ekran
 * za računar, a ovaj samo prikazuje.
 */
export default {
  name: "CompanyMobileMultiMeals",
  extends: CompanyDesktopMultiMeals,
  mixins: [hasMultiMobile],
  components: { ReportMobileShiftRows },
  computed: {
    cards() {
      return this.rows
        .filter((row) => row.total > 0)
        .map((row) => ({
          key: row.key,
          name: row.name,
          total: row.total,
          shifts: this.visibleShifts
            .filter((shift) => row[shift.key] > 0)
            .map((shift) => ({ id: shift.id, quantity: row.text[shift.key] })),
        }));
    },
  },
};
</script>
